import type { Subject } from '@kids-lms/types';

export interface Interest {
  id: string;
  label: string;
  emoji: string;
  subjects: Subject[];
  color: string;
}

export const INTERESTS: Interest[] = [
  { id: 'animals', label: 'Animals', emoji: '🐾', subjects: ['science'], color: 'var(--kid-tangerine)' },
  { id: 'space', label: 'Space', emoji: '🚀', subjects: ['science'], color: 'var(--kid-violet)' },
  { id: 'dinosaurs', label: 'Dinosaurs', emoji: '🦕', subjects: ['science', 'history'], color: 'var(--kid-meadow)' },
  { id: 'drawing', label: 'Drawing', emoji: '🎨', subjects: ['art'], color: 'var(--kid-berry)' },
  { id: 'music', label: 'Music', emoji: '🎵', subjects: ['music'], color: 'var(--kid-dandelion)' },
  { id: 'sports', label: 'Sports', emoji: '⚽', subjects: ['general'], color: 'var(--kid-ocean)' },
  { id: 'cooking', label: 'Cooking', emoji: '🍕', subjects: ['general', 'science'], color: 'var(--kid-coral)' },
  { id: 'computers', label: 'Computers', emoji: '💻', subjects: ['coding'], color: 'var(--kid-sky)' },
  { id: 'stories', label: 'Stories', emoji: '📚', subjects: ['english'], color: 'var(--kid-bubblegum)' },
  { id: 'numbers', label: 'Numbers', emoji: '🔢', subjects: ['math'], color: 'var(--kid-ocean)' },
  { id: 'nature', label: 'Nature', emoji: '🌿', subjects: ['science', 'geography'], color: 'var(--kid-meadow)' },
  { id: 'history', label: 'History', emoji: '🏛️', subjects: ['history'], color: 'var(--kid-violet)' },
];

export function interestsToSubjects(selectedInterests: string[]): Subject[] {
  const subjectSet = new Set<Subject>(['general']);
  for (const interest of INTERESTS) {
    if (selectedInterests.includes(interest.id)) {
      for (const subject of interest.subjects) {
        subjectSet.add(subject);
      }
    }
  }
  return Array.from(subjectSet);
}
